module.exports = __webpack_public_path__ + "static/media/webdesign-services-img8.c9db58e5.jpg";